import React from 'react';
import PropTypes from 'prop-types';
import { formatUSD } from '@sparefoot/react-core/utils/format';

import { Link } from 'components/core/Link';
import { H3, Text } from 'components/core/Typography';
import { FacilityRatingLabel } from 'components/facility/FacilityRatingLabel';
import { StarRating } from 'components/review/StarRating';

import './nearbyFacilityRow.scss';

export function NearbyFacilityRow({ facility, ratingRenderLabel }) {
	const { name, url, location, distance, lowestPrice } = facility;
	return (
		<div className="nearby-facility-row">
			<div className="row-details">
				<div className="row-title">
					<H3
						size="small"
						last
					>
						<Link
							to={url}
							productClick
							className="facility-link"
						>
							{name}
						</Link>
					</H3>
				</div>
				<div className="row-location">
					<Text
						itemProp="address"
						itemScope
						itemType="http://schema.org/PostalAddress"
						color="priceBlue"
						size="tiny"
						weight="standard"
					>
						{`${location.city}, ${location.state} ${location.zip}`}
					</Text>
					<Text
						color="priceBlue"
						weight="extraBold"
						size="tiny"
					>
						{' | '}
						{distance} {distance === 1 ? 'mile' : 'miles'} away
					</Text>
				</div>
			</div>
			{!!facility.reviews.number && (
				<div className="row-rating">
					<StarRating rating={facility.reviews.average} />
					<FacilityRatingLabel
						numberOfRatings={facility.reviews.number}
						average={facility.reviews.average}
						reviewsUrl={`${facility.url}#facility-page-user-reviews`}
						renderLabel={ratingRenderLabel}
						review={facility.highestReview}
						reviewTitle={`What customers are saying about ${facility.name}`}
					/>
				</div>
			)}
			<div className="row-price">
				<Link
					to={url}
					className="row-price-link"
				>
					{formatUSD(lowestPrice)}
				</Link>
			</div>
		</div>
	);
}

NearbyFacilityRow.propTypes = {
	facility: PropTypes.object,
	ratingRenderLabel: PropTypes.func,
};

NearbyFacilityRow.defaultProps = {
	ratingRenderLabel: FacilityRatingLabel,
};

export default NearbyFacilityRow;
